// extracted by mini-css-extract-plugin
export default {"section":"OpenableSection_section__m1bxk","header":"OpenableSection_header__D8VpB","button":"OpenableSection_button__ZcHQx","title":"OpenableSection_title__nCEWd"};